// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"FAQ_FAQ__14wwX","Wrap":"FAQ_Wrap__2kY3F","Item":"FAQ_Item__3ReIy"};